(() => {
  // V2.4 route repair: the legacy Shopify About handle may not exist.
  // Keep old bookmarks/nav targets from landing on a 404.
  if (window.location.pathname.replace(/\/+$/, '') === '/pages/about') {
    window.location.replace('/pages/abou-us');
  }
})();

(() => {
  const reveal = () => {
    const items = document.querySelectorAll('.tc-reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      items.forEach(el => el.classList.add('is-visible'));
      return;
    }
    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -35px' });
    items.forEach(el => io.observe(el));
  };
  document.addEventListener('DOMContentLoaded', reveal);
  document.addEventListener('shopify:section:load', reveal);
})();

(() => {
  const root = document.getElementById('tc-market');
  const input = root?.querySelector('[data-market-search]');
  const box = root?.querySelector('[data-market-suggest]');
  if (!input || !box || input.dataset.tcEnhanced === '1') return;
  input.dataset.tcEnhanced = '1';
  input.type = 'search';
  input.setAttribute('results','0');
  input.name = 'collectible_query';
  if(input.form){let compatibility=input.form.querySelector('input[type=hidden][name=q]');if(!compatibility){compatibility=document.createElement('input');compatibility.type='hidden';compatibility.name='q';input.form.append(compatibility);}const sync=()=>{compatibility.value=input.value;};sync();input.addEventListener('input',sync);input.form.addEventListener('submit',sync);}
  input.autocomplete = 'off';
  input.setAttribute('autocorrect','off');
  input.removeAttribute('list');
  input.form?.setAttribute('autocomplete','off');
  box.id = 'tc-market-suggestions';
  box.setAttribute('role', 'listbox');
  box.setAttribute('aria-label', 'Matching collectibles');
  input.setAttribute('role', 'combobox');
  input.setAttribute('aria-controls', box.id);
  input.setAttribute('aria-expanded', 'false');
  const esc = v => String(v ?? '').replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]));
  const safeImage = value => {
    try { const url = new URL(value, location.origin); return ['https:', 'http:'].includes(url.protocol) ? url.href : ''; } catch { return ''; }
  };
  const money = item => {
    const value = Number(item.price);
    if (item.price == null || !Number.isFinite(value) || value <= 0) return 'Price pending';
    try { return item.currency ? new Intl.NumberFormat('en-US', {style:'currency',currency:item.currency}).format(value) : value.toFixed(2); } catch { return value.toFixed(2); }
  };
  let timer, controller, revision = 0, active = -1;
  const choose = index => {const links=Array.from(box.querySelectorAll('a'));if(!links.length)return;active=Math.max(0,Math.min(index,links.length-1));links.forEach((link,i)=>link.setAttribute('aria-selected',String(i===active)));input.setAttribute('aria-activedescendant',links[active].id);links[active].scrollIntoView({block:'nearest'});};
  const open = value => { box.dataset.open = value ? '1' : '0'; input.setAttribute('aria-expanded', String(value));if(!value){active=-1;input.removeAttribute('aria-activedescendant');} };
  const cancel = () => { clearTimeout(timer); controller?.abort(); revision++; };
  const render = (items, query, mode) => {
    if (!items.length) {
      box.innerHTML = mode === 'loading'
        ? '<div class="tc-suggest-empty" role="status"><strong>Preparing the catalog preview.</strong><span>Type a card, set or product name to search now.</span></div>'
        : '<div class="tc-suggest-empty" role="status"><strong>No matching identities found.</strong><span>Try a set name, card number or another search.</span></div>';
    } else box.innerHTML = '<div class="tc-suggest-head">'+(mode === 'popular' ? 'EXPLORE THE CATALOG' : 'MATCHING COLLECTIBLES')+'</div>'+items.map((item, i) => {
      const href = item.id ? '/apps/triple-c/market?productId='+encodeURIComponent(item.id) : '/apps/triple-c/market?q='+encodeURIComponent(item.title || query);
      const detail = [item.setName, item.cardNumber ? '#'+item.cardNumber : '', item.variant, item.grade].filter(Boolean).join(' · ');
      const meta = [item.franchise,item.productForm,item.source,item.currency].filter(Boolean).join(' · ');
      const image = safeImage(item.image);
      return '<a role="option" aria-selected="false" id="tc-market-option-'+i+'" href="'+href+'">'+(image ? '<img src="'+esc(image)+'" alt="" loading="lazy">' : '<div class="tc-result-placeholder"><span>TC</span></div>')+'<div class="tc-suggest-copy"><strong>'+esc(item.title || 'Collectible')+'</strong><span>'+esc(detail || meta)+'</span>'+(detail && meta ? '<small>'+esc(meta)+'</small>' : '')+'</div><b>'+esc(money(item))+'</b></a>';
    }).join('');
    box.querySelectorAll('img').forEach(img => img.addEventListener('error', () => { img.replaceWith(Object.assign(document.createElement('span'), {className:'tc-result-placeholder',textContent:'TC'})); }, {once:true}));
    open(true);
    active = -1;
  };
  const run = (immediate = false) => {
    cancel();
    const current = revision;
    const query = input.value.trim();
    if (query.length < 2) { open(false); box.replaceChildren(); return; }
    timer = setTimeout(async () => {
      controller = new AbortController();
      try {
        const endpoint = input.dataset.suggestEndpoint || '/apps/triple-c/market-suggest';
        const response = await fetch(endpoint+(query.length >= 2 ? '?q='+encodeURIComponent(query) : ''), {headers:{Accept:'application/json'},credentials:'same-origin',cache:'no-store',signal:controller.signal});
        const data = await response.json();
        if (!response.ok || data.ok === false || !Array.isArray(data.items)) throw new Error('Unavailable');
        if (current === revision) render(data.items, query, data.mode);
      } catch (error) {
        if (error.name === 'AbortError' || current !== revision) return;
        box.innerHTML = '<div class="tc-suggest-empty" role="status"><strong>Market suggestions are unavailable.</strong><span>Please try the full search, or return in a moment.</span></div>';
        open(true);
      }
    }, immediate ? 0 : 130);
  };
  input.addEventListener('focus', () => { if (input.value.trim().length >= 2) run(true); });
  input.addEventListener('input', () => run());
  input.addEventListener('keydown', event => {
    if (event.key === 'Escape') { cancel(); open(false); }
    if (box.dataset.open === '1' && ['ArrowDown','ArrowUp'].includes(event.key)) {event.preventDefault();choose(active+(event.key==='ArrowDown'?1:-1));}
    if(event.key==='Enter'&&box.dataset.open==='1'&&active>=0){const item=box.querySelectorAll('a')[active];if(item){event.preventDefault();location.assign(item.href);}}
  });
  box.addEventListener('keydown', event => {
    const links = Array.from(box.querySelectorAll('a'));
    const index = links.indexOf(document.activeElement);
    if (event.key === 'Escape') { event.preventDefault(); input.focus(); cancel(); open(false); }
    if (event.key === 'ArrowDown') { event.preventDefault(); links[Math.min(index+1, links.length-1)]?.focus(); }
    if (event.key === 'ArrowUp') { event.preventDefault(); if (index <= 0) input.focus(); else links[index-1]?.focus(); }
  });
  root.querySelector('[data-market-form]')?.addEventListener('submit', () => { cancel(); open(false); });
  document.addEventListener('click', event => { if (event.target !== input && !box.contains(event.target)) { cancel(); open(false); } });
})();


(() => {
  const initDealDeskPreview = () => {
    document.querySelectorAll('[data-deal-preview]').forEach((root) => {
      if (root.dataset.tcPreviewReady === '1') return;
      root.dataset.tcPreviewReady = '1';
      const video = root.querySelector('[data-deal-preview-video]');
      const toggle = root.querySelector('[data-deal-preview-toggle]');
      if (!video || !toggle) return;
      const sync = () => {
        const playing = !video.paused && !video.ended && video.readyState >= 2;
        root.classList.toggle('is-playing', playing);
        toggle.textContent = playing ? '❚❚ Pause preview' : '▶ Preview';
        toggle.setAttribute('aria-label', playing ? 'Pause Deal Desk preview' : 'Play Deal Desk preview');
      };
      video.addEventListener('playing', sync);
      video.addEventListener('pause', sync);
      video.addEventListener('loadeddata', () => { root.classList.remove('is-failed'); sync(); });
      video.addEventListener('error', () => { root.classList.add('is-failed'); sync(); });
      toggle.addEventListener('click', () => {
        if (video.paused) video.play().catch(() => root.classList.add('is-failed'));
        else video.pause();
      });
      video.play().then(sync).catch(sync);
      window.setTimeout(sync, 350);
    });
  };
  document.addEventListener('DOMContentLoaded', initDealDeskPreview);
  document.addEventListener('shopify:section:load', initDealDeskPreview);
  window.addEventListener('pageshow', initDealDeskPreview);
})();


(() => {
  const init = () => {
    document.querySelectorAll('[data-tc-shop-toggle]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = '1';
      const wrap = button.closest('.tc-nav__shop-wrap');
      const setOpen = value => { wrap?.classList.toggle('is-open', value); button.setAttribute('aria-expanded', String(value)); };
      button.addEventListener('click', () => setOpen(!wrap.classList.contains('is-open')));
      wrap?.addEventListener('keydown', event => { if (event.key === 'Escape') { setOpen(false); button.focus(); } });
      document.addEventListener('click', event => { if (!wrap?.contains(event.target)) setOpen(false); });
    });
    document.querySelectorAll('.tc-nav__inner>a').forEach(link => {
      if (link.pathname.replace(/\/+$/, '') === location.pathname.replace(/\/+$/, '')) link.setAttribute('aria-current','page');
    });
    document.querySelectorAll('[data-deal-calculator]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready='1';
      const output=root.querySelector('[data-deal-output]');
      root.querySelector('[data-deal-calculate]')?.addEventListener('click', () => {
        const cost=root.querySelector('[data-deal-cost]'), reference=root.querySelector('[data-deal-reference]'), fees=root.querySelector('[data-deal-fees]');
        const c=Number(cost.value), r=Number(reference.value), f=fees.value === '' ? 0 : Number(fees.value);
        if (!cost.value || !reference.value || ![c,r,f].every(Number.isFinite) || c<=0 || r<=0 || f<0) {output.textContent=output.dataset.prompt;return;}
        const difference=r-c-f;
        output.textContent=output.dataset.resultLabel+new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(difference)+' ('+(difference/r*100).toFixed(1)+'%)';
      });
    });
    const inspectFrame = frame => {
      const fallback=frame.parentElement.querySelector('[data-preview-fallback]');
      if (!fallback) return;
      let ready=false;
      try {
        const doc=frame.contentDocument;
        const text=doc?.body?.innerText || '';
        // A generic proxy JSON response is not a rendered feature.
        const trimmed=text.trim();
        const hasFeature=doc?.querySelector('main, [data-triplec-feature], #tc-market, #tc-community, #tc-seller');
        ready=Boolean(doc && doc.location.href !== 'about:blank' && hasFeature && trimmed && !/^[{[]/.test(trimmed) && !/third-party app error|application error|page not found|profile not found|access denied/i.test(trimmed) && !doc.querySelector('form[action*="/account/login"]'));
      } catch {}
      fallback.hidden=ready;
      frame.style.visibility=ready ? 'visible' : 'hidden';
    };
    document.querySelectorAll('.tc-roadmap-card__visual>iframe').forEach(frame => {
      if (frame.dataset.ready) return;
      frame.dataset.ready='1';
      frame.addEventListener('load',()=>inspectFrame(frame));
      setTimeout(()=>inspectFrame(frame),4500);
    });
    const modal=document.querySelector('[data-roadmap-modal]');
    if (!modal || modal.dataset.tcReady) return;
    modal.dataset.tcReady='1';
    const panel=modal.querySelector('[role=dialog]'), frame=modal.querySelector('[data-roadmap-frame]'), title=modal.querySelector('#tc-roadmap-preview-title'), openFull=modal.querySelector('[data-roadmap-open]');
    let trigger=null, oldOverflow='';
    const close=()=>{modal.hidden=true;document.documentElement.style.overflow=oldOverflow;if(frame)frame.src='about:blank';trigger?.focus();};
    frame?.addEventListener('load',()=>inspectFrame(frame));
    document.querySelectorAll('[data-roadmap-preview]').forEach(button=>button.addEventListener('click',()=>{
      const src=button.dataset.roadmapPreview;
      if (!src || !src.startsWith('/') || src.startsWith('//') || !frame) return;
      trigger=button; oldOverflow=document.documentElement.style.overflow;
      title.textContent=button.dataset.roadmapPreviewTitle || 'Feature preview';
      openFull.href=src; frame.src=src; frame.style.visibility='hidden';
      const fallback=panel.querySelector('[data-preview-fallback]');
      if(fallback){
        const representation=button.parentElement.querySelector('[data-preview-fallback]')?.cloneNode(true);
        if(representation){
          representation.querySelectorAll('[id]').forEach(element=>{element.id='tc-modal-'+element.id;});
          representation.querySelectorAll('label[for]').forEach(element=>{element.htmlFor='tc-modal-'+element.htmlFor;});
          fallback.replaceChildren(...representation.childNodes);
          fallback.classList.add('tc-feature-preview');
        }
        fallback.hidden=false;
      }
      modal.hidden=false;document.documentElement.style.overflow='hidden';
      modal.querySelector('button[data-roadmap-close]')?.focus();
      setTimeout(()=>{if(!modal.hidden)inspectFrame(frame);},4500);
    }));
    document.querySelectorAll('[data-roadmap-scroll]').forEach(button=>button.addEventListener('click',()=>{
      const target=button.dataset.roadmapScroll; if(target?.startsWith('#'))document.querySelector(target)?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
    }));
    modal.querySelectorAll('[data-roadmap-close]').forEach(button=>button.addEventListener('click',close));
    document.addEventListener('keydown',event=>{
      if(modal.hidden)return;
      if(event.key==='Escape'){event.preventDefault();close();}
      if(event.key==='Tab'){
        const controls=Array.from(panel.querySelectorAll('button,a[href],input,select,textarea,iframe,[tabindex]:not([tabindex="-1"])')).filter(element=>element.offsetWidth>0&&!element.disabled);
        const first=controls[0],last=controls[controls.length-1];
        if(event.shiftKey&&document.activeElement===first){event.preventDefault();last?.focus();}
        else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first?.focus();}
      }
    });
  };
  if (document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();

// The theme owns its navigation; feature-card markup must never be relabelled.
(() => {
  const nav=document.querySelector('.tc-nav [data-seller-nav]');
  if(nav)fetch('/apps/triple-c/seller-nav-status',{credentials:'same-origin',cache:'no-store'})
    .then(r=>r.ok?r.json():null).then(data=>{
      if(!data || !['/apps/triple-c/seller','/apps/triple-c/sell-with-us'].includes(data.href))return;
      nav.href=data.href;nav.textContent=data.ownerSellerCenter?'Owner Dashboard':data.verifiedSeller?'Seller Center':'Sell With Us';
    }).catch(()=>{});
  document.addEventListener('click',event=>{
    const button=event.target.closest('[data-rip-preview]');if(!button)return;
    const art=button.closest('[data-preview-fallback]')?.querySelector('.tc-tile-art--rips');if(!art)return;
    const revealed=art.classList.toggle('is-revealed');button.textContent=revealed?'Reset preview':'Reveal preview';
    art.querySelectorAll('.tc-art-card').forEach((card,i)=>{card.style.transform=revealed?'translateY(-4px) rotate(0deg)': '';card.style.transition='transform .25s';card.style.transitionDelay=(i*70)+'ms';});
  });
})();
